export function areDepsEqual(prevDeps: unknown[], deps: unknown[]): boolean {
  return prevDeps.every((prevDep, prevDepIndex) => prevDep === deps[prevDepIndex]);
}
